import { render, staticRenderFns } from "./InputDocumentPanelUser.vue?vue&type=template&id=39507e84&"
import script from "./InputDocumentPanelUser.vue?vue&type=script&lang=ts&"
export * from "./InputDocumentPanelUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports